import { buildConnection } from '$app/queue-hub-connection-builder'
import apiConnection from '$app/plugins/api-connection'
import Vue from 'vue';

const connection = buildConnection();

// State
const state = {
  completedProcessingQueue: null,
  processingQueues: []
}

// Mutations
const mutations = {
  setCompletedProcessingQueue(state, completedProcessingQueue) {
    state.completedProcessingQueue = completedProcessingQueue;
  },
  setProcessingQueues(state, processingQueues) {
    state.processingQueues = processingQueues;
  }
}

// Actions
const actions = ({
  async connect({ commit }) {
    connection.onQueueUpdated((eventArgs) => {
      commit('setProcessingQueues', eventArgs.openProcessingQueues);
      commit('setCompletedProcessingQueue', eventArgs.completedProcessingQueue);

      if (eventArgs.completedProcessingQueue) {
        if (eventArgs.completedProcessingQueue.status === 'Failed') {
          var snackbarMessage = `The task '${eventArgs.completedProcessingQueue.processDescription}' failed`

          if (eventArgs.completedProcessingQueue.exceptionsCaptured) {
            snackbarMessage += `\n ${eventArgs.completedProcessingQueue.exceptionsCaptured}`
          }

          this._vm.$snackbar(snackbarMessage, 'error');
        } else {
          this._vm.$snackbar(`The task '${eventArgs.completedProcessingQueue.processDescription}' has completed`);
        }
      }
    });

    await connection.connect();
  },
  async disconnect() {
    await connection.disconnect();
  },
  cancel({ commit }, queueId) {
    const processingQueues = state.processingQueues;
    const queueToCancel = processingQueues.filter(q => q.queueId === queueId)[0];

    apiConnection.put('processingqueue/cancel', queueToCancel);
  }
})

// Getters
const getters = {
  processingQueues: state => state.processingQueues,
  allowNewProcess: _ => Vue.prototype.$auth([Vue.prototype.$roles.arrpAdmin]) && (!state.processingQueues || !state.processingQueues.length)
}

export default ({
  namespaced: true,
  state,
  getters,
  mutations,
  actions
})
